module.exports = __webpack_public_path__ + "static/media/LV.144ae609.svg";